/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { createContext } from "react";

/**
 * @type {ComponentPositionContext}
 */
const defaultContext = {};

export const ComponentPositionContext = createContext(defaultContext);
